import { render } from "./DetalharTipoPagamento.vue?vue&type=template&id=c4fd4fa8&scoped=true"
import script from "./DetalharTipoPagamento.vue?vue&type=script&lang=js"
export * from "./DetalharTipoPagamento.vue?vue&type=script&lang=js"

import "./DetalharTipoPagamento.vue?vue&type=style&index=0&id=c4fd4fa8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4fd4fa8"]])

export default __exports__